import * as React from "react";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlusCircle,
    faList,
    faFileExcel,
    faBan
} from "@fortawesome/free-solid-svg-icons";
import { MenuRender } from "../../../../Shared/GridComponents/CommonComponents";
import { CandidateStatus, ReqStatus } from "../../../../Shared/AppConstants";
import { downloadExcel, initialDataState, successToastr } from "../../../../../HelperMethods";
import { GridDetailRow } from "@progress/kendo-react-grid";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import auth from "../../../../Auth";
import { EXCEL_DOWNLOAD_INPROGRESS } from "../../../../Shared/AppMessages";
import axios from "axios";
import { State } from "aws-sdk/clients/forecastservice";
import { toODataString } from "@progress/kendo-data-query";
import { KendoFilter } from "../../../../ReusableComponents";

export const ExportExcel = (state,candidateId) => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => Data(state,candidateId)}>
            <FontAwesomeIcon icon={faFileExcel} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Export to Excel{" "}
        </div>
    )
}


export const CustomMenu = (state,candidateId) => {
    return (
        <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={MenuRender}>
                <MenuItem render={() => ExportExcel(state,candidateId)} />
            </MenuItem>
        </Menu>
    );
};

const Data = (state, candidateId) => {
   
    var dataState = initialDataState;
    var finalState = {
        ...dataState,
        take: null,
        skip: 0,
    };
    var queryStr = `${toODataString(finalState, { utcDates: true })}`;

    var queryParams = `candidateId eq ${candidateId}`;
    var vendorId = auth.getVendor();
    var clientId = auth.getClient();
    if (state.isVendorRole && vendorId) {
        queryParams += ` and submittedVendorId eq ${vendorId}`;
        if (clientId) {
            queryParams += ` and clientId eq ${clientId}`;
        }
    }
   
    var finalQueryString = KendoFilter(finalState, queryStr, queryParams);

    successToastr(EXCEL_DOWNLOAD_INPROGRESS);
    axios.get(`api/candidates/candshare/excel?${finalQueryString}`).then((res) => {
        if (res) {
            downloadExcel("OwnerShip History.xlsx", res.data);
        }
    });
}
export function DefaultActions(props, candidateId) {
    const { dataItem } = props;
    if (!dataItem.candShareRequestId) return[];

    var defaultActions = [
        {
            action: "View",
            permCode: AppPermissions.CAND_SHARE_TALENT_POOL_VIEW,
            nextState: "",
            icon: "faEye",
            linkUrl: `/candidate/share/${candidateId}`,
        }

    ];
    return defaultActions;
}
